import { action, observable } from 'mobx';
import axios from 'axios';

class TrialSignupClass {
    @observable formStep = 1;
    @observable isTrialFlow = false;
    @observable isTrialFeatureDisabled = false;
    @observable isCodeSent = false;
    @observable performingTrialSignup = false;
    @observable signupTrialSuccessful = false;
    @observable wrongPinError = false;
    @observable validatePhoneNumberError = '';
    @observable trialSignupError = '';
    @observable freeTrialAge = '';
    @observable codeSend = 'Code sent!';

    // setters
    @action setIsTrialFlow(bool) {
        if (typeof bool === 'boolean') {
            this.isTrialFlow = bool;
        }
    }

    @action setIsTrialFeatureDisabled(bool) {
        if (typeof bool === 'boolean') {
            this.isTrialDisabled = bool;
        }
    }

    @action setIsCodeSent(bool) {
        if (typeof bool === 'boolean') {
            this.isCodeSent = bool;
        }
    }

    @action setFormStep(num) {
        if (typeof num === 'number' && num >= 1 && num <= 2) {
            this.formStep = num;
        }
    }

    @action setPerformingTrialSignup(bool) {
        if (typeof bool === 'boolean') {
            this.performingTrialSignup = bool;
        }
    }

    @action setSignupTrialSuccessful(bool) {
        if (typeof bool === 'boolean') {
            this.signupTrialSuccessful = bool;
        }
    }

    @action setWrongPinError(bool) {
        if (typeof bool === 'boolean') {
            this.wrongPinError = bool;
        }
    }

    @action setValidatePhoneNumberError(str) {
        if (typeof str === 'string') {
            this.validatePhoneNumberError = str;
        }
    }

    @action setCodeResend(str) {
        if (typeof str === 'string') {
            this.codeSend = str;
        }
    }

    @action setTrialSignupError(str) {
        if (typeof str === 'string') {
            this.trialSignupError = str;
        }
    }

    @action setFreeTrialAge(str) {
        if (typeof str === 'string') {
            this.freeTrialAge = str;
        }
    }

    // send user pin
    @action sendUserPin(sessionID, contactPhone, callUser = false, errorCallback) {
        axios.post(`/api/ValidatePhoneNumber?numberLockSessionId=${sessionID}&contactPhone=${contactPhone}&validationType=${callUser ? 'call' : 'sms'}`)
            .then((response) => {
                // if valid response set isCodeSent to true
                if (response.data !== true) throw new Error('response data is false');

                if (this.isCodeSent === true) {
                    this.setCodeResend(callUser ? 'Code resent by call!' : 'Code resent by text!');
                } else {
                    this.setIsCodeSent(true);
                }
            }).catch((err) => {
                const errorData = err.response.data.Details[0] ? err.response.data.Details[0] : err;

                return errorCallback(errorData);
            });
    }

    // perform sign up
    @action signupTrial(sessionID, signupTrialObject, successCallback, errorCallback) {
        this.setPerformingTrialSignup(true);
        axios.post(`/api/signupfreetrial?numberLockSessionId=${sessionID}`, signupTrialObject)
            .then((response) => {
                this.setSignupTrialSuccessful(true);
                successCallback(response.data);
            }).catch((err) => {
                errorCallback(err);
            }).then(() => this.setPerformingTrialSignup(false));
    }

    // computed
}

const trialSignupStore = new TrialSignupClass();
export { trialSignupStore, TrialSignupClass };
